export default __webpack_public_path__ + "static/media/accessory_diffuse-min.392da505.jpg";